var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosebtn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 8,
    viewBox: "0 0 6 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.08566 4.08988C0.890399 3.89462 0.890399 3.57804 1.08566 3.38277L4.26764 0.200794C4.4629 0.00553207 4.77949 0.00553207 4.97475 0.200794C5.17001 0.396056 5.17001 0.712639 4.97475 0.907901L2.14632 3.73633L4.97475 6.56476C5.17001 6.76002 5.17001 7.0766 4.97475 7.27186C4.77949 7.46712 4.4629 7.46712 4.26764 7.27186L1.08566 4.08988ZM2.24023 4.23633H1.43921V3.23633H2.24023V4.23633Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosebtn);
export default __webpack_public_path__ + "static/media/closebtn.c1d8f57cceacc44d30c962deee1ac6ef.svg";
export { ForwardRef as ReactComponent };